import LoginModul from './loginStore';
import ClientModul from './clientStore';
import UserModul from './userStore';
import WorksheetModul from './worksheetStore';
import HelperModul from './helperStore';
import DictionaryModul from './dictionaryStore';
import EmailNotificationModul from './emailNotificationStore';

export const state = {

};

export const getters = {

};

export const mutations = {

};

export const actions = {

};

export const modules = {
    LoginModul,
    ClientModul,
    UserModul,
    WorksheetModul,
    HelperModul,
    DictionaryModul,
    EmailNotificationModul
};



// WEBPACK FOOTER //
// ./src/store/globalStore.js